// https://stackoverflow.com/a/8260383/550047
export const extractId = (youtubeUrl) => {
  const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/
  const firstMatch = youtubeUrl.match(regExp)
  if (firstMatch !== null) {
    const match = firstMatch[1].replace(/(\n|\r)+$/, '')
    return (match && match.length == 11) ? match : console.log(`[VIDEOBUG-1] in src/utils/youtubeHelper.js ${youtubeUrl}`);
  }
  else {
    console.log(`[VIDEOBUG-2] in src/utils/youtubeHelper.js ${youtubeUrl}`);
    return ""
  }
}

export const extractURL = (coreEmbedBlock) => {
  return coreEmbedBlock.originalContent.replace( /(<([^>]+)>)/ig, '').match(/(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/)[0]
}
